import { IconButton } from '@dev-spendesk/grapes';
import { Handle, Position, useReactFlow, type NodeProps } from '@xyflow/react';

import {
  getSiblingNodesCenterPosition,
  NEW_NODE_OFFSET,
} from '../../helpers/layoutNavigation';
import { useRegisterNodeHeight } from '../../hooks/useRegisterNodeHeight';
import { useWorkflowContext } from '../../state/WorkflowContext';

export type NewConditionNodeData = {
  nodeType: 'newConditionNode';
  parentId: string;
};

const handleStyle = {
  background: 'transparent',
  border: 'none',
  width: 0,
  height: 0,
};

export const NewConditionNode = ({
  id,
  data,
}: NodeProps & { data: NewConditionNodeData }) => {
  const { createAndConnectNode, getSiblingNodes, newNodeId } =
    useWorkflowContext();
  const reactFlow = useReactFlow();
  const isCreationLocked = Boolean(newNodeId);
  const nodeReference = useRegisterNodeHeight<HTMLDivElement>(id);

  return (
    <div ref={nodeReference} className="flex min-h-[100px] items-center">
      <IconButton
        variant="secondaryNeutral"
        onClick={() => {
          createAndConnectNode({ sourceNodeId: data.parentId });
          const siblingNodes = getSiblingNodes(data.parentId);
          const siblingNodesCenterPosition =
            getSiblingNodesCenterPosition(siblingNodes);
          reactFlow.setCenter(
            siblingNodesCenterPosition.x + NEW_NODE_OFFSET,
            siblingNodesCenterPosition.y,
            { zoom: 1, duration: 1000 },
          );
        }}
        disabled={isCreationLocked}
        size={64}
        iconName="circle-plus"
        aria-label="plus"
      />
      <Handle
        style={handleStyle}
        type="target"
        id="leftHandle"
        position={Position.Left}
      />
    </div>
  );
};
